// extracted by mini-css-extract-plugin
export default {"bubble_generator":"BubbleGenerator_bubble_generator__g7azV","canvas":"BubbleGenerator_canvas__97M6Y"};